import { FC } from 'react';
import { Link } from 'react-router-dom';
import { MiniPicture } from '../icon/MiniPicture';
import { QuickLinkType } from './links.types';

interface Props {
  link: QuickLinkType;
}

export const MiniPictureLink: FC<Props> = ({ link }) => {
  const styling = 'flex gap-3 items-center';
  const content = (
    <>
      <MiniPicture url={link.pictureUrl!} />
      <div className="flex-1">
        <div className="font-semibold text-lg leading-tight text-primary-std pb-2">{link.title}</div>
        <div className="font-semibold leading-tight text-secondary-std">{link.subtitle}</div>
      </div>
    </>
  );

  if (link.to) {
    return (
      <Link to={link.to} className={styling}>
        {content}
      </Link>
    );
  } else {
    return (
      <button type="button" onClick={link.onClick} className={styling}>
        {content}
      </button>
    );
  }
};
